$(document).ready(function () {
    //Populating prescription contact select fields
    //adding data to right sphere
    $.each(window.CONTACT_SPH_VALS, function (i, item) {
        $(".bs_pre_contact_right_sphere")[0]?.append(new Option(item.text, item.value));
    });

    //adding data to right bc
    $.each(window.CONTACT_BC_VALS, function (i, item) {
        $(".bs_pre_contact_right_bc")[0]?.append(new Option(item.text, item.value));
    });
    //adding data to right dia
    $.each(window.CONTACT_DIA_VALS, function (i, item) {
        $(".bs_pre_contact_right_dia")[0]?.append(new Option(item.text, item.value));
    });
    //adding data to right cyl
    $.each(window.CONTACT_CYL_VALS, function (i, item) {
        $(".bs_pre_contact_right_cyl")[0]?.append(new Option(item.text, item.value));
    });
    //adding data to right axis
    $.each(window.CONTACT_AXIS_VALS, function (i, item) {
        $(".bs_pre_contact_right_axis")[0]?.append(new Option(item.text, item.value));
    });
    //adding data to left sphere
    $.each(window.CONTACT_SPH_VALS, function (i, item) {
        $(".bs_pre_contact_left_sphere")[0]?.append(new Option(item.text, item.value));
    });
    //adding data to left bc
    $.each(window.CONTACT_BC_VALS, function (i, item) {
        $(".bs_pre_contact_left_bc")[0]?.append(new Option(item.text, item.value));
    });
    //adding data to left dia
    $.each(window.CONTACT_DIA_VALS, function (i, item) {
        $(".bs_pre_contact_left_dia")[0]?.append(new Option(item.text, item.value));
    });
    //adding data to left cyl
    $.each(window.CONTACT_CYL_VALS, function (i, item) {
        $(".bs_pre_contact_left_cyl")[0]?.append(new Option(item.text, item.value));
    });
    //adding data to left axis
    $.each(window.CONTACT_AXIS_VALS, function (i, item) {
        $(".bs_pre_contact_left_axis")[0]?.append(new Option(item.text, item.value));
    });

    //Populating prescription lens select fields
    //adding data to right sphere
    $.each(window.LENS_SPH_VALS, function (i, item) {
        $(".bs_pre_lens_right_sphere")[0]?.append(new Option(item.text, item.value));
    });
    //adding data to left sphere
    $.each(window.LENS_SPH_VALS, function (i, item) {
        $(".bs_pre_lens_left_sphere")[0]?.append(new Option(item.text, item.value));
    });
    //adding data to right cyl
    $.each(window.LENS_CYL_VALS, function (i, item) {
        $(".bs_pre_lens_right_cyl")[0]?.append(new Option(item.text, item.value));
    });
    //adding data to left cyl
    $.each(window.LENS_CYL_VALS, function (i, item) {
        $(".bs_pre_lens_left_cyl")[0]?.append(new Option(item.text, item.value));
    });
    //adding data to right axis
    $.each(window.LENS_AXIS_VALS, function (i, item) {
        $(".bs_pre_lens_right_axis")[0]?.append(new Option(item.text, item.value));
    });
    //adding data to left axis
    $.each(window.LENS_AXIS_VALS, function (i, item) {
        $(".bs_pre_lens_left_axis")[0]?.append(new Option(item.text, item.value));
    });
    //adding data to right add
    $.each(window.LENS_ADD_VALS, function (i, item) {
        $(".bs_pre_lens_right_add")[0]?.append(new Option(item.text, item.value));
    });
    //adding data to left add
    $.each(window.LENS_ADD_VALS, function (i, item) {
        $(".bs_pre_lens_left_add")[0]?.append(new Option(item.text, item.value));
    });
    //adding data to right pupillary distance
    $.each(window.LENS_PUP_DIST_VALS, function (i, item) {
        $(".bs_pre_lens_right_pup_dist")[0]?.append(new Option(item.text, item.value));
    });
    //adding data to left pupillary distance
    $.each(window.LENS_PUP_DIST_VALS, function (i, item) {
        $(".bs_pre_lens_left_pup_dist")[0]?.append(new Option(item.text, item.value));
    });
});

